import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Introduction from "../pages/introduction/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/introduction",
    element: <Introduction />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
